// d3-free module: imported by loading skeletons that must stay out of the
// heavy chart chunk. Do not add imports from chart implementation modules.
export const CHART_DIMENSIONS = {
  BASE_WIDTH: 776,
  BASE_HEIGHT: 378,
  MAX_WIDTH: 1440,
  MAX_HEIGHT: 630,
} as const;
